import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaPlay, FaUserPlus } from 'react-icons/fa';
import './Selection.css';

function Selection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
      <div className="selection-page-container">
          <h1>{t("selection.title")}</h1>
          <div className="selection-container">
              <div className="selection-block">
                  <p>{t("selection.block1_text")}</p>
                  <button
                      onClick={() => navigate("/step2")}
                      className="selection-button"
                  >
                      <FaPlay />
                      {t("selection.block1_button")}
                  </button>
              </div>
              <div className="selection-block">
                  <p>{t("selection.block2_text")}</p>
                  <p className='petittext'>{t("selection.block3_text")}</p>
                  <button
                      onClick={() => navigate("/home")}
                      className="selection-button"
                  >
                      <FaUserPlus />
                      {t("selection.block2_button")}
                  </button>
                  
              </div>
          </div>
      </div>
  );
}

export default Selection;
